import libphonenumber from 'google-libphonenumber';
import { fundsAmountsList } from '@fund-base/constants/funds/funds.constants';

/** Snaps a funding range to the nearest steps in fundsAmountsList. */
export function snapToFundingSliderSteps(min?: number, max?: number): { min: number; max: number } {
  const steps = fundsAmountsList.map(s => s.value);
  const snap = (val: number) =>
    steps.reduce((prev, curr) => (Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev));
  return {
    min: min != null ? snap(min) : 0,
    max: max != null ? snap(max) : steps[steps.length - 1],
  };
}

/** Returns true if the given deadline date is strictly before today (time-independent). */
export function isDeadlinePast(deadline: Date | string): boolean {
  return new Date(deadline) < new Date(new Date().toDateString());
}

/** Opens Google Calendar "create event" page pre-filled with the task details.
 *  Event is scheduled on the deadline day from 10:00 to 11:00 local time. */
export function openGoogleCalendar(name: string, deadlineStr: string, description?: string): void {
  const pad = (n: number) => String(n).padStart(2, '0');
  const formatGcal = (d: Date) =>
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;

  const start = new Date(deadlineStr + 'T10:00:00');
  const end = new Date(deadlineStr + 'T11:00:00');

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: name,
    dates: `${formatGcal(start)}/${formatGcal(end)}`,
    ...(description ? { details: description } : {}),
  });

  window.open(`https://calendar.google.com/calendar/render?${params.toString()}`, '_blank');
}

export function isNull(value: any) {
  return value === undefined || value === null;
}

export function isNotNull(value: any) {
  return !isNull(value);
}

export const phoneUtility = libphonenumber.PhoneNumberUtil.getInstance();

// fund grants
export function fundGrantRangeToString(minValue: number, maxValue: number) {
  if (minValue === 0 && maxValue === 5000) {
    return '<$4,999';
  } else if (minValue === 1000000 && maxValue === 1000000) {
    return '$1M+';
  } else {
    const minValueText = fundsAmountsList?.find(amount => amount.value === minValue);
    const maxValueText = fundsAmountsList?.find(amount => amount.value === maxValue);
    return `${minValueText?.text}-${maxValueText?.text}`;
  }
}

export function fundGrantRangeToMinMaxValues(fundsGrant: string) {
  if (fundsGrant === '<$4,999') {
    return { minValue: 0, maxValue: 5000 };
  } else if (fundsGrant === '$1M+') {
    return { minValue: 1000000, maxValue: 1000000 };
  } else {
    const valuesInArray = fundsGrant.split('-');
    const minValue = fundsAmountsList.find(amount => amount.text === valuesInArray[0]);
    const maxValue = fundsAmountsList?.find(amount => amount.text === valuesInArray[1]);
    return { minValue: minValue?.value, maxValue: maxValue?.value };
  }
}

export function filtersFormatter(counts: any) {
  let filters: any[] = [];

  filters.push({ categoryKey: 'phone', properties: [{ key: 'phone', count: counts?.phone?.doc_count }] });
  filters.push({ categoryKey: 'email', properties: [{ key: 'email', count: counts?.email?.doc_count }] });
  filters.push({
    categoryKey: 'limitations',
    properties: [{ key: 'limitations', count: counts?.limitations?.doc_count }],
  });
  filters.push({
    categoryKey: 'delegations',
    properties: [{ key: 'delegations', count: counts?.delegation?.doc_count }],
  });
  filters.push({ categoryKey: 'webSite', properties: [{ key: 'webSite', count: counts?.web?.doc_count }] });
  filters.push({
    categoryKey: 'newestFunds',
    properties: [{ key: 'newestFunds', count: counts?.newestFunds?.doc_count }],
  });
  filters.push({
    categoryKey: 'showHiddenFunds',
    properties: [{ key: 'showHiddenFunds', count: counts?.hiddenFunds?.doc_count }],
  });

  let types: any = [];
  let categories: any = [];
  let months: any = [];

  let typesMap: any = { type_business: 2, type_fund: 1, type_other: 4, type_rfp: 3 };

  Object.keys(counts).forEach(key => {
    if (key.startsWith('type_')) {
      types.push({ key: typesMap[key], count: counts[key]['doc_count'] });
    }

    if (key.startsWith('cat_')) {
      categories.push({ key: key.replace('cat_', ''), count: counts[key]['doc_count'] });
    }

    if (key.startsWith('month_')) {
      months.push({ key: key.replace('month_', ''), count: counts[key]['doc_count'] });
    }
  });

  filters.push({ categoryKey: 'MonthsToApply', properties: months });
  filters.push({ categoryKey: 'type', properties: types });
  filters.push({ categoryKey: 'areaOfInterests', properties: categories });

  return filters;
}

